import { Box, Button, IconButton, Paper } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import { createElement } from 'react'
import { ElementFactory, QuestionPanelDynamicModel, Serializer } from 'survey-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'
import { styles } from './SurveyPanelDynamic.styles'

const CUSTOM_TYPE = 'surveypaneldynamic'

export class SurveyPanelDynamicModel extends QuestionPanelDynamicModel {
  constructor (name: string) {
    super(name)
    this.titleLocation = 'hidden'
  }

  getType (): string {
    return CUSTOM_TYPE
  }
}

export function registerPanelDynamic (): void {
  ElementFactory.Instance.registerElement(
    CUSTOM_TYPE,
    (name) => {
      return new SurveyPanelDynamicModel(name)
    }
  )

  Serializer.addClass(
    CUSTOM_TYPE,
    [],
    function () {
      return new SurveyPanelDynamicModel('')
    },
    'paneldynamic'
  )

  ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionPanelDynamic, props)
  })
}

export class SurveyQuestionPanelDynamic extends SurveyQuestionElementBase {
  get question (): SurveyPanelDynamicModel {
    return this.questionBase as SurveyPanelDynamicModel
  }

  renderElement (): JSX.Element {
    const panels = this.question.panels
    const addText = this.question.panelAddText ?? 'Add New'

    return (
      <Box sx={styles.container}>
        {panels.map((panel, index) => (
          <Paper key={panel.id} elevation={0} sx={styles.paper}>
            <Box sx={styles.header}>
              <Box sx={styles.title}>
                {this.question.title} {index >= 0 && `(${index + 2})`}
              </Box>
              {this.question.canRemovePanel && (
                <IconButton
                  onClick={() => { this.question.removePanelUI(index) }}
                  aria-label="delete"
                  color="primary"
                  size="small"
                >
                  Delete <DeleteIcon />
                </IconButton>
              )}
            </Box>

            {panel.questions.map((q) => (
              <Box key={q.name} sx={styles.questionWrapper}>
                {this.creator.createQuestionElement(q)}
              </Box>
            ))}
          </Paper>
        ))}

        {this.question.canAddPanel && (
          <Button
            endIcon={<AddIcon />}
            onClick={() => this.question.addPanelUI()}
            sx={styles.addButton}
          >
            {addText}
          </Button>
        )}
      </Box>
    )
  }
}
